import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  codeTag: {
    paddingTop: theme.layout.padding.p2,
    paddingRight: theme.layout.padding.p5,
    paddingBottom: theme.layout.padding.p2,
    paddingLeft: theme.layout.padding.p5,
    backgroundColor: 'var(--color-neutral-050)',
    color: 'var(--color-contrast-neutral-050)',
    borderRadius: 'var(--border-radius-sm)',
    border: 'var(--border-neutral-thin)',
    fontSize: theme.typography.fontSizes.md,
    userSelect: 'all'
  }
}))

function CodeTag ({ children, className, onClick, style }) {
  const classes = useStyles()

  return (
    <div className={clsx(classes.codeTag, className)} style={style} onClick={onClick}>{children}</div>
  )
}

CodeTag.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

CodeTag.defaultProps = {
  onClick: () => {}
}

export default CodeTag
